/**
 * Production-safe logger.
 * In development: prints to console. In production: silent (or could send to Sentry/etc).
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logError = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export const logWarn = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export const logInfo = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.info(...args);
  }
};
